import React from 'react'
import { Box, Button, Container, Typography, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import sectionbgImg from '../../../../images/section-bg.jpg'
import { BlogDesignBtn, CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common';
import { Link } from 'react-router-dom';


const Blog = () => {
    const theme = useTheme();
    const blogPosts = [
        {
            date: "MAY, 2025",
            title: "7 Best Fabrics for Daily Wear Clothes",
            image: "/images/blogs/blog-1.jpg",
        },
        {
            date: "MAY, 2025",
            title: "Trendy Fabric Types for Men’s Wear",
            image: "/images/blogs/blog-2.jpg",
        },
        {
            date: "JUN, 2025",
            title: "How to Choose the Right Fabric Material",
            image: "/images/blogs/blog-3.jpg",
        },
    ];


    return (
        <>
            <Box sx={{
                backgroundImage: `url(${sectionbgImg})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'relative',
                zIndex: '1',

                backgroundAttachment: 'fixed',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: '-1',
                    backgroundColor: '#0000005e',
                    top: '0'
                }
            }}>
                <Box sx={{ pt: 18, pb: 18 }}>
                    <Box sx={{ textAlign: 'center', pb: 6 }}>
                        <CommonTitle margin={'0 0 10px 0'} text={'Recent Blogs'} />
                        <CommonHeading text={' News  &  Blogs '} />
                    </Box>
                    <Container maxWidth='xl'>
                        <Grid container>
                            {
                                blogPosts.map((val, index) => {
                                    return (
                                        <Grid xs={12} md={6} lg={4} sx={{ px: 2, my: { lg: 0, xs: 3 } }}>
                                            <Box sx={{
                                                position: 'relative',
                                                height: { sm: '440px', xs: '360px' },
                                                '&:hover': {
                                                    '& .blog-content': {
                                                        width: '100%',
                                                        backgroundColor: '#3c342e'
                                                    },
                                                    '& .date': {
                                                        color: theme.palette.primary.gold
                                                    },
                                                    color: '#fff'
                                                }
                                            }}>
                                                <img className="blog-img" src={val.image} width='100%' height='auto' style={{ objectFit: 'cover' }} />
                                                <Box className="blog-content" sx={{
                                                    position: 'absolute', backgroundColor: '#fff', width: '78%', right: '0', top: { sm: '46%', xs: '36%' }, transition: 'width 0.3s ease-in-out'
                                                }}>
                                                    <Typography className='date' sx={{
                                                        fontFamily: theme.palette.typography.fontFamily1, fontSize: { sm: '14px', xs: '10px' }, padding: { sm: '30px 38px 12px', xs: '30px 18px 12px' }, textTransform: 'uppercase',
                                                        letterSpacing: '3.5px'
                                                    }}>{val.date}</Typography>
                                                    <Typography sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: { sm: '28px', xs: '16px' }, padding: { sm: '0px 38px 20px', xs: '0px 18px 20px' } }}>
                                                        {val.title}
                                                    </Typography>
                                                    <Box sx={{ margin: { sm: "0px 38px 20px", xs: "0px 18px 20px" } }}>
                                                        <Link to="/shop">
                                                            <BlogDesignBtn width={'160px'} text={'shop the sales'} />
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid >
                    </Container>
                </Box>
            </Box >
        </>
    )
}

export default Blog